import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class ActivityService {
    static getActivities(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`activities?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => { x.activity.date = parseDate(x.activity.date); });
            return w;
        })));
    }
    static fetchActivity(oid) {
        return lastValueFrom(BaseService.get(`activities/${oid}`).pipe(map(activity => {
            activity.payload.date = parseDate(activity.payload.date);
            return activity;
        })));
    }
    static saveActivity(dto) {
        return lastValueFrom(BaseService.save(`activities`, dto));
    }
    static deleteActivity(oid) {
        return lastValueFrom(BaseService.delete(`activities/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Stats
    // ----------------------------------------------------------------------
    static getActivityStats(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`activities-stats?filter=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Bulk Invoice Status
    // ----------------------------------------------------------------------
    static bulkChangeActivitiesInvoiceStatus(filter, status) {
        return lastValueFrom(BaseService.post(`activities-bulk-invoice-status/${status}`, filter));
    }
}
